import { useMemo } from 'react';
import withErrorBoundary from '../ErrorBoundary';
import { UI_UPGRADE_BANNER } from '../_core/common/constants/ErrorBoundaryNames';
import { getQueryParam } from '../_core/utils/commMethodOverrides';
import { useFetchUpgradeBannerConfig } from '../hooks/useFetchUpgradeBannerConfig';
import LimitPackBanner from './banner/LimitPackBanner';
import LoadingBanner from './banner/LoadingBanner';
import RemoveBrandingBanner from './banner/RemoveBrandingBanner';
import RemoveBrandingBannerWithBadge from './banner/RemoveBrandingBannerWithBadge';
import UsageLimitBanner from './banner/UsageLimitBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const UIUpgradeBanner = ({
  upgradeKey,
  limit,
  value,
  displayThreshold,
  marginStyle = {},
  'data-test-id': dataTestId,
  showFTS002Variant,
  title
}) => {
  const displayBannerOverride = getQueryParam('displayUpgradeBanner');
  const isValueBelowDisplayThreshold = useMemo(() => {
    return !displayBannerOverride && displayThreshold && value !== undefined && value >= 0 && value < displayThreshold;
  }, [displayThreshold, value, displayBannerOverride]);
  const {
    loading,
    error,
    data
  } = useFetchUpgradeBannerConfig(upgradeKey, limit, value);
  if (isValueBelowDisplayThreshold) {
    return null;
  }
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingBanner, {
      marginStyle: marginStyle
    });
  }
  if (error || !data) {
    return null;
  }
  const {
    upgradeConfig
  } = data;
  if (limit && value !== undefined && value >= 0 && upgradeConfig.pointType === 'USAGE_LIMIT_BANNER') {
    return /*#__PURE__*/_jsx(UsageLimitBanner, {
      upgradePoint: upgradeConfig,
      limit: limit,
      value: value,
      hasReachedLimit: value >= limit,
      displayBannerOverride: !!displayBannerOverride,
      displayThreshold: displayThreshold,
      marginStyle: marginStyle,
      "data-test-id": dataTestId
    });
  }
  if (limit && value !== undefined && value >= 0 && upgradeConfig.pointType === 'LIMIT_PACK_BANNER') {
    return /*#__PURE__*/_jsx(LimitPackBanner, {
      upgradePoint: upgradeConfig,
      limit: limit,
      value: value,
      displayThreshold: displayThreshold,
      displayBannerOverride: !!displayBannerOverride,
      marginStyle: marginStyle,
      "data-test-id": dataTestId
    });
  }
  if (upgradeConfig.pointType === 'REMOVE_BRANDING_BANNER') {
    if (showFTS002Variant && title) {
      return /*#__PURE__*/_jsx(RemoveBrandingBannerWithBadge, {
        upgradePoint: upgradeConfig,
        marginStyle: marginStyle,
        "data-test-id": dataTestId,
        title: title
      });
    } else {
      return /*#__PURE__*/_jsx(RemoveBrandingBanner, {
        upgradePoint: upgradeConfig,
        marginStyle: marginStyle,
        "data-test-id": dataTestId
      });
    }
  }
  return null;
};
export default withErrorBoundary(UIUpgradeBanner, {
  boundaryName: UI_UPGRADE_BANNER
});